//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { email, required } from 'vuelidate/lib/validators';
import * as api from '@/services/api';

export default {
  data() {
    return {
      formData: {
        email: '',
        password: ''
      },
      errorMessage: null,
      loading: false,
      forgotPassword: {
        email: '',
        errorMessage: null
      }
    };
  },
  validations: {
    formData: {
      email: { email, required },
      password: { required }
    },
    forgotPassword: { email: { email, required } }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.hash === '#forgot-password') {
        this.$refs.modalForgotPassword.open();
      }
    });
  },
  methods: {
    async signIn() {
      this.errorMessage = null;
      this.$v.formData.$touch();
      if (this.$v.formData.$invalid) return;

      try {
        this.$sentry.setUser({
          email: this.formData.email
        });
        const data = await this.$auth.loginWith('local', {
          data: {
            email: this.formData.email,
            password: this.formData.password
          }
        });
        this.$router.push('/dashboard');
      } catch (err) {
        const { error, message } = err.response.data;

        if (message.toLowerCase() === 'email not verified') {
          this.$refs.modalEmailNotVerified.open();
        } else {
          this.errorMessage = message;
        }
      }
    },
    async signInGoogle() {
      try {
        this.errorMessage = null;
        await this.$auth.loginWith('google');
      } catch (err) {
        this.errorMessage = err.message;
      }
    },
    async signInFacebook() {
      try {
        this.errorMessage = null;
        await this.$auth.loginWith('facebook');
      } catch (err) {
        this.errorMessage = err.message;
      }
    },
    async resendConfirmationEmail() {
      this.$refs.modalEmailNotVerified.close();
      try {
        await api.resendConfirmationEmail(this.formData.email);
        this.$refs.modalEmailConfirmationSent.open();
      } catch (err) {
        const { message } = err.response.data;
        this.$toast.error(`Error: ${message}.`);
      }
    },
    clearForgotPassword() {
      this.forgotPassword.email = '';
      this.forgotPassword.errorMessage = '';
      this.$v.forgotPassword.$reset();
    },
    async handleForgotPassword() {
      this.$v.forgotPassword.$touch();
      if (this.$v.forgotPassword.$invalid) return;
      try {
        await api.forgotPassword(this.forgotPassword.email);
        this.$toast.success(
          `We've sent an email to ${this.forgotPassword.email} with instructions on how to reset your password.`
        );
        this.$refs.modalForgotPassword.close();
      } catch (err) {
        this.forgotPassword.errorMessage =
          err.response?.data?.message ||
          err?.message ||
          'Somethign went wrong. Please try again later.';
      }
    }
  }
};
